import { Component, computed, EventEmitter, Output, Signal, signal, ViewChild, WritableSignal } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { SharedService } from 'src/app/services/shared.service';
import { Size, Sizes } from 'src/app/models/types/Product/Product.type';
import { ModalComponent } from '../../modal/modal.component';

@Component({
  selector: 'app-size-list-modal',
  imports: [
    ModalComponent,
    TranslateModule
  ],
  templateUrl: './size-list-modal.component.html',
  styleUrl: './size-list-modal.component.scss'
})
export class SizeListModalComponent {

  @ViewChild('modal', { static: false }) modal!: ModalComponent;

  @Output('handleSelectSize') handleSelectSize: EventEmitter<Size> = new EventEmitter();

  private _sizeList: WritableSignal<Sizes> = signal([]);
  protected sizeList: Signal<Sizes> = computed(() => this._sizeList());

  protected selectedSize: WritableSignal<Size | null> = signal(null);
  protected disabledConfirm: Signal<boolean> = computed(() => !this.selectedSize());

  constructor(
    public sharedService: SharedService
  ) { }

  openModal(sizeList: Sizes, selectedSize: Size | null) {
    this._sizeList.set(sizeList);
    this.selectedSize.set(selectedSize);
    this.modal.buildModal(() => this.handleClose(), 'md');
  }

  handleConfirm() {
    let size = this.selectedSize();
    if (size) {
      this.handleSelectSize.emit(size);
    }
    this.handleClose()
  }

  private handleClose() {
    this.modal.dismiss();
  }

}
